<template>
  <div id="examinations-history-present-illness">
  
    <!-- images uploaded by patient -->
    <!-- <patient-image-uploads></patient-image-uploads> -->


    <!-- ************************************* history of present illness ************************************* -->
        
    <v-row>
      <v-col cols="12">
        <h3 class="text--darken-1 mb-1" >
          History of Present Illness
          <v-checkbox dense hide-details v-model="bindVtt" class="mt-0 text-primary" label="Bind with VTT" @click="bindModelToVTT"></v-checkbox>
        </h3>
        <VueEditor v-model="history" :editor-toolbar="customToolbar" ></VueEditor>
        
      </v-col>
    </v-row>

    <!-- ************************************* history of present illness ************************************* -->

    <p>&nbsp;</p>
    <hr />
    
    <h3 class="grey--text text--darken-3 mt-10">Review of Systems</h3>

    <v-row>

      <!-- ************************************* CONSTITUTIONAL ************************************* -->
      
      <form-examination-item class="examination-instance" v-model="constitutional" label="Constitutional">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="constitutional" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('constitutional')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in constitutional_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('constitutional', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="constitutional_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ************************************* CONSTITUTIONAL ************************************* -->



      
      <!-- ************************************* HEAD ************************************* -->
      
      <form-examination-item class="examination-instance" v-model="head" label="Head including face">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="head" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('head')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in head_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('head', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="head_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ************************************* HEAD ************************************* -->



      
      <!-- ************************************* EYES ************************************* -->
      
      <form-examination-item class="examination-instance" v-model="eyes" label="Eyes">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="eyes" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('eyes')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in eyes_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('eyes', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="eyes_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ************************************* EYES ************************************* -->

      



      <!-- ************************************* NOSE ************************************* -->
      
      <form-examination-item class="examination-instance" v-model="ears_nose_mouth_throat" label="Ears, Nose, Mouth, Throat">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="ears_nose_mouth_throat" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('ears_nose_mouth_throat')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in ears_nose_mouth_throat_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('ears_nose_mouth_throat', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="ears_nose_mouth_throat_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ************************************* NOSE ************************************* -->





      <!-- ******************************** CARDIOVASCULAR ******************************** -->
      
      <form-examination-item class="examination-instance" v-model="cardiovascular" label="Cardiovascular">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="cardiovascular" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('cardiovascular')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in cardiovascular_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('cardiovascular', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="cardiovascular_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ******************************** CARDIOVASCULAR ******************************** -->





      <!-- ******************************** RESPIRATORY ******************************** -->
      
      <form-examination-item class="examination-instance" v-model="respiratory" label="Respiratory">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="respiratory" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('respiratory')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in respiratory_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('respiratory', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="respiratory_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ******************************** RESPIRATORY ******************************** -->

      



      <!-- ******************************** gastrointestinalintestinal ******************************** -->
      
      <form-examination-item class="examination-instance" v-model="gastrointestinal" label="Gastrointestinal">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="gastrointestinal" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('gastrointestinal')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in gastrointestinal_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('gastrointestinal', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="gastrointestinal_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ******************************** gastrointestinalintestinal ******************************** -->





      <!-- ******************************** genitourinary-urinary ******************************** -->

      <form-examination-item class="examination-instance" v-model="genitourinary" label="Genito-urinary">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="genitourinary" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('genitourinary')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in genitourinary_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('genitourinary', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="genitourinary_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ******************************** genitourinary-urinary ******************************** -->




      <!-- ******************************** INTEGUMENTARY ******************************** -->

      <form-examination-item class="examination-instance" v-model="integumentary" label="Integumentary">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="integumentary" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('integumentary')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in integumentary_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('integumentary', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="integumentary_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ******************************** INTEGUMENTARY ******************************** -->

      


      <!-- ******************************** Musculoskeletal ******************************** -->
      
      <form-examination-item class="examination-instance" v-model="musculoskeletal" label="Musculoskeletal">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="musculoskeletal" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('musculoskeletal')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in musculoskeletal_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('musculoskeletal', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="musculoskeletal_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ******************************** Musculokeletal ******************************** -->


      

      <!-- ******************************** Neurologic ******************************** -->
      
      <form-examination-item class="examination-instance" v-model="neurologic" label="Neurologic">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="neurologic" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('neurologic')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in neurologic_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('neurologic', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="neurologic_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- ******************************** Neurologic ******************************** -->



      
      <!-- *************************** psychiatriciatric Symptoms *************************** -->

      <form-examination-item class="examination-instance" v-model="psychiatric" label="Psychiatric Symptoms">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="psychiatric" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('psychiatric')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in psychiatric_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('psychiatric', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="psychiatric_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- *************************** psychiatriciatric Symptoms *************************** -->




      <!-- *************************** psychiatriciatric Symptoms *************************** -->

      <form-examination-item class="examination-instance" v-model="hema_lymph_immunologic" label="Hema/Lymph/Immunologic Symptoms">
        <template slot="sub">
          <v-slide-y-transition>
            <v-row v-show="hema_lymph_immunologic" class="mx-5" dense>
              <div class="form-reset-wrapper">
                <div @click="resetItems('hema_lymph_immunologic')" class="ros-reset">RESET</div>
                <form-examination-sub-item v-for="(item,key) in hema_lymph_immunologic_items" :key="key" v-model="item.value" :label="item.name" @check="updateItem('hema_lymph_immunologic', item.name, $event)"></form-examination-sub-item>
              </div>
              <form-examination-remark v-model="hema_lymph_immunologic_note"></form-examination-remark>
            </v-row>
          </v-slide-y-transition>
        </template>
      </form-examination-item>

      <!-- *************************** psychiatriciatric Symptoms *************************** -->

    </v-row>

    <p>&nbsp;</p>
    <hr />
    <p>&nbsp;</p>
    <BR />

  </div>
</template>

<script>
  import { VueEditor } from "vue2-editor";

  export default {
    name: 'FormExamination',

    components: {
      FormExaminationItem: () => import('./ExaminationItem.vue'),
      FormExaminationSubItem: () => import('./ExaminationSubItem.vue'),
      FormExaminationRemark: () => import('./ExaminationRemark.vue'),
      // PatientImageUploads: () => import('./PatientImageUploads.vue'),
      VueEditor
    },

    data() {
      return {
        bindVtt: false,
        isLoading: false,
        customToolbar: [
          [{ font: [] }],
          [{ size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike"],
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ color: [] }, { background: [] }],
          ["link"],
        ],

        fullToolbar: [
          [{ font: [] }],
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          [{ size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike"],
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          [{ header: 1 }, { header: 2 }],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ color: [] }, { background: [] }],
          ["link", "image", "video", "formula"],
          [{ direction: "rtl" }],
          ["clean"]
        ],
      }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    watch: {
      activeIndex() {
        this.isLoading = true
        setTimeout(() => {
          this.loadSavedData()
        }, 500)
      },

      head(val) {
        if (!val) {
          this.head_items.forEach(e => { e.active = undefined })
          this.head_note = ''
        }
      },

      eyes(val) {
        console.log("eyes");
        console.log(val);
        if (!val) {
          this.eyes_items.forEach(e => { e.active = undefined })
          this.eyes_note = ''
        }
      },

      ears(val) {
        if (!val) {
          this.ears_items.forEach(e => { e.active = undefined })
          this.ears_note = ''
        }
      },

      skin(val) {
        if (!val) {
          this.skin_items.forEach(e => { e.active = undefined })
          this.skin_note = ''
        }
      },

      ears_nose_mouth_throat(val) {
        if (!val) {
          this.ears_nose_mouth_throat_items.forEach(e => { e.active = undefined })
          this.nose_note = ''
        }
      },

      cardiovascular(val) {
        if (!val) {
          this.cardiovascular_items.forEach(e => { e.active = undefined })
          this.cardiovascular_note = ''
        }
      },

      respiratory(val) {
        if (!val) {
          this.respiratory_items.forEach(e => { e.active = undefined })
          this.respiratory_note = ''
        }
      },

      gastrointestinal(val) {
        if (!val) {
          this.gastrointestinal_items.forEach(e => { e.active = undefined })
          this.gastrointestinal_note = ''
        }
      },

      genitourinary(val) {
        if (!val) {
          this.genitourinary_items.forEach(e => { e.active = undefined })
          this.genitourinary_note = ''
        }
      },

      integumentary(val) {
        if (!val) {
          this.integumentary_items.forEach(e => { e.active = undefined })
          this.integumentary_note = ''
        }
      },

      musculoskeletal(val) {
        if (!val) {
          this.musculoskeletal_items.forEach(e => { e.active = undefined })
          this.musculoskeletal_note = ''
        }
      },

      neurologic(val) {
        if (!val) {
          this.neurologic_items.forEach(e => { e.active = undefined })
          this.neurologic_note = ''
        }
      },

      psychiatric(val) {
        if (!val) {
          this.psychiatric_items.forEach(e => { e.active = undefined })
          this.psychiatric_note = ''
        }
      },

      hema_lymph_immunologic(val) {
        if (!val) {
          this.hema_lymph_immunologic_items.forEach(e => { e.active = undefined })
          this.hema_lymph_immunologic_note = ''
        }
      }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    computed: {
      activeIndex() { return this.$store.getters['consultation/activeIndex'] },
      
      constitutional: {
        get() { return this.$store.getters['examination/constitutional'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'constitutional', active: val}) }
      },

      constitutional_note: {
        get() { return this.$store.getters['examination/constitutional_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'constitutional', note: val}) }
      },


      // head
      head: {
        get() { return this.$store.getters['examination/head'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'head', active: val}) }
      },

      // head_item : return this.$store.getters['examination/head'],

      head_note: {
        get() { return this.$store.getters['examination/head_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'head', note: val}) }
      },
      
      // eyes
      eyes: {
        get() { return this.$store.getters['examination/eyes'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'eyes', active: val}) }
      },

      eyes_note: {
        get() { return this.$store.getters['examination/eyes_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'eyes', note: val}) }
      },

      // nose, mouth, throat
      ears_nose_mouth_throat: {
        get() { return this.$store.getters['examination/ears_nose_mouth_throat'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'ears_nose_mouth_throat', active: val}) }
      },
      ears_nose_mouth_throat_note: {
        get() { return this.$store.getters['examination/ears_nose_mouth_throat_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'ears_nose_mouth_throat', note: val}) }
      },
      // cardiovascularvascular
      cardiovascular: {
        get() { return this.$store.getters['examination/cardiovascular'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'cardiovascular', active: val}) }
      },
      cardiovascular_note: {
        get() { return this.$store.getters['examination/cardiovascular_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'cardiovascular', note: val}) }
      },
      // respiratoryratory
      respiratory: {
        get() { return this.$store.getters['examination/respiratory'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'respiratory', active: val}) }
      },
      respiratory_note: {
        get() { return this.$store.getters['examination/respiratory_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'respiratory', note: val}) }
      },
      // gastrointestinalintestinal
      gastrointestinal: {
        get() { return this.$store.getters['examination/gastrointestinal'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'gastrointestinal', active: val}) }
      },
      gastrointestinal_note: {
        get() { return this.$store.getters['examination/gastrointestinal_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'gastrointestinal', note: val}) }
      },
      // genitourinary-urinary
      genitourinary: {
        get() { return this.$store.getters['examination/genitourinary'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'genitourinary', active: val}) }
      },
      genitourinary_note: {
        get() { return this.$store.getters['examination/genitourinary_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'genitourinary', note: val}) }
      },
      
      // integumentarymentary
      integumentary: {
        get() { return this.$store.getters['examination/integumentary'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'integumentary', active: val}) }
      },
      integumentary_note: {
        get() { return this.$store.getters['examination/integumentary_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'integumentary', note: val}) }
      },

      // musculoskeletal
      musculoskeletal: {
        get() { return this.$store.getters['examination/musculoskeletal'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'musculoskeletal', active: val}) }
      },
      musculoskeletal_note: {
        get() { return this.$store.getters['examination/musculoskeletal_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'musculoskeletal', note: val}) }
      },
      // neurologic
      neurologic: {
        get() { return this.$store.getters['examination/neurologic'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'neurologic', active: val}) }
      },
      neurologic_note: {
        get() { return this.$store.getters['examination/neurologic_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'neurologic', note: val}) }
      },
      // psychiatriciatric symptoms
      psychiatric: {
        get() { return this.$store.getters['examination/psychiatric'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'psychiatric', active: val}) }
      },
      psychiatric_note: {
        get() { return this.$store.getters['examination/psychiatric_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'psychiatric', note: val}) }
      },
      // psychiatriciatric symptoms
      hema_lymph_immunologic: {
        get() { return this.$store.getters['examination/hema_lymph_immunologic'] },
        set(val) { this.$store.commit('examination/updateActive', {code: 'hema_lymph_immunologic', active: val}) }
      },
      hema_lymph_immunologic_note: {
        get() { return this.$store.getters['examination/hema_lymph_immunologic_note'] },
        set(val) { this.$store.commit('examination/updateNote', {code: 'hema_lymph_immunologic', note: val}) }
      },


      constitutional_items() { return this.$store.getters['examination/constitutional_items'] },
      head_items() { return this.$store.getters['examination/head_items'] },
      eyes_items() { return this.$store.getters['examination/eyes_items'] },
      ears_nose_mouth_throat_items() { return this.$store.getters['examination/ears_nose_mouth_throat_items'] },
      cardiovascular_items() { return this.$store.getters['examination/cardiovascular_items'] },
      respiratory_items() { return this.$store.getters['examination/respiratory_items'] },
      gastrointestinal_items() { return this.$store.getters['examination/gastrointestinal_items'] },
      genitourinary_items() { return this.$store.getters['examination/genitourinary_items'] },
      musculoskeletal_items() { return this.$store.getters['examination/musculoskeletal_items'] },
      integumentary_items() { return this.$store.getters['examination/integumentary_items'] },
      neurologic_items() { return this.$store.getters['examination/neurologic_items'] },
      psychiatric_items() { return this.$store.getters['examination/psychiatric_items'] },
      hema_lymph_immunologic_items() { return this.$store.getters['examination/hema_lymph_immunologic_items'] },
      

      // used for loading saved subcheckbox items
      item_names() { return this.$store.getters['examination/load_items'] },

      case_info() { return this.$store.getters['cases/case'] },
      case_id() { return this.$store.getters['cases/case_id'] },

      // history of present illness saved in cases.js
      history: {
        get() { return this.$store.getters['cases/history'] },
        set(val) { this.$store.commit('cases/updateHistory', val) }
      },
    },

    async mounted() {
      // await this.$store.dispatch('cases/fetchCase', this.case_id);
      // await this.$store.commit('examination/loadSavedData', this.case_info.examinations);

      this.isLoading = true
      setTimeout(() => {
        this.loadSavedData()
      }, 5000)
    },

    methods: {
      bindModelToVTT () {
        if (this.bindVtt) {
          this.$vtt.setModel('history');
          this.$vtt.bindEditor('history');
          let self = this;
          this.$vtt.startSpeechListener((text) => { 
            console.log("history text: ", text);
            self.history = `${self.history || ''} ${text}`;
          }, 'history')
        } else {
          this.$vtt.setModel('')
          this.$vtt.unbindEditor('history');
        }
      },
      async loadSavedData() {
        await this.item_names.forEach(name => {
          var data_items = this[`${name}_items`] // labtest
          data_items.forEach(data => {
            var store_items = this[`store_${name}_items`]
            data.active = store_items.includes(data.name)
            // if (data.active) {
            //   console.log('data.active', data.name)
            //   this.updateItem(name, data.name, true)
            // }
          });
        });
        this.isLoading = false
      },

      async updateItem(code, item, value) {
        this.$store.commit('examination/updateItems', {code: code, item: item, value: value})
      },

      async resetItems(code) {
        this.$store.commit('examination/resetItems', code)
      }

    }
  }
</script>

<style lang="scss" scoped>
  .examination-instance { background: #e9e9e9; }
  .examination-instance:nth-child(odd) {
    background: #f6f6f6;
  }

  .form-reset-wrapper {
    float: left;
    width: 100%;
    position: relative;
  }

  .ros-reset {
    background-color: #258bf5;
    border-radius: 15px;
    padding: 5px 15px;
    color: #fff;
    font-size: 12px;
    width: fit-content;
    position: absolute;
    right: 0;
    top: -45px;
    font-weight: bold;
    cursor: pointer;
  }
</style>